import { useSyncExternalStore } from "react";
import { useRowSelectionContext } from "../context/RowSelectionContext";

export const useRowSelectionCount = () => {
  const { store } = useRowSelectionContext();
  return useSyncExternalStore(store.subscribe, () => store.getSelectionCount());
};
